import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from '@react-oauth/google';

import App from "./App.jsx";
import { UserProvider } from "./context/UserContext.jsx";
import "./Styles/User/App.css"; // Import CSS here for global availability


// Debug: Log API URL being used
// Get Google Client ID from environment variables
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

createRoot(document.getElementById("root")).render(

    <UserProvider>
    <GoogleOAuthProvider clientId={googleClientId}>
    <App />
    </GoogleOAuthProvider>
    </UserProvider>
);
